import Store from 'store/store';

Store.on('SET_MUTED', muteUnmute => fire('audio-click', 'home', muteUnmute ? 'muted' : 'unmuted'));
Store.on('TRACK_QUIZPHOTOBOOTH_VIEW', view => {
	if (!view) return;
	if (view !== 'form') return;
	fire('view', 'quiz-form', '');
});
Store.on('TRACK_QUIZPHOTOBOOTH_FORM_SUBMITTED', () => fire('submit-click', 'quiz-form', ''));
Store.on('TRACK_QUIZPHOTOBOOTH_BACK_TO_HOME', () => fire('backtohome-click', 'shareable', ''));


const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	const acceptedCats = window.powCategories?.get() || [];
	if (!acceptedCats.includes('PERFORMANCE')) return;
	window.firePowsterCustomEvent(action, cat, label);
};